import { useWeatherWalls } from './getWeatherWalls';

import {
  WallFolderWithWeatherRelations,
  WeatherWallWindowRelations,
} from 'types';

export const transformWallsWithFolders = (
  walls: WeatherWallWindowRelations[]
): WallFolderWithWeatherRelations[] => {
  if (!walls || walls.length === 0) return [];
  const folders: WallFolderWithWeatherRelations[] = [];
  for (const wall of walls) {
    if (!('folder' in wall) || !wall.folder) continue;
    const associatedFolder = folders.find(
      (folder) => folder.id === wall.folder_id
    );
    // If the folder doesn't exist, make it
    if (!associatedFolder) {
      const newFolder: WallFolderWithWeatherRelations = {
        ...wall.folder,
        weatherWalls: [wall],
      };
      folders.push(newFolder);
      // Otherwise, add the wall to an existing folder
    } else {
      associatedFolder.weatherWalls.push(wall);
    }
  }
  // Sort walls by position inside folders
  for (const folder of folders) {
    folder.weatherWalls = folder.weatherWalls.sort((wall1, wall2) => {
      if (wall1.folder_position === null || wall1.folder_position === undefined)
        return 1;
      if (wall2.folder_position === null || wall2.folder_position === undefined)
        return -1;
      return wall1.folder_position - wall2.folder_position;
    });
  }
  return folders.sort((folder1, folder2) => {
    if (folder1.position === null) return 1;
    if (folder2.position === null) return -1;
    return folder1.position - folder2.position;
  });
};
type UseWallOptions = {
  userId: number;
};

export const useWeatherWallsByFolder = ({ userId }: UseWallOptions) =>
  useWeatherWalls(userId, (data: WeatherWallWindowRelations[]) =>
    transformWallsWithFolders(data)
  );
